import { createI18n } from 'vue-i18n'

// Import locale messages from JSON files
import en from '../locales/en/index.js'
// import fr from '../locales/fr/index.js'
// import nl from '../locales/nl/index.js'

const messages = {
  en
  // fr,
  // nl
}

export const i18n = createI18n({
  legacy: false,
  locale: 'en',
  fallbackLocale: 'en',
  messages,
  missingWarn: import.meta.env.DEV,
  fallbackWarn: import.meta.env.DEV,
  silentTranslationWarn: !import.meta.env.DEV,
  silentFallbackWarn: !import.meta.env.DEV,
  globalInjection: true
})
